import { h } from "hyperapp";
import { Title, Header, SubHeading, Button, Paragraphs, Hr, Loading, WalletButton } from "./components";
const screens = {};

export default function (state, actions) {
	const loaderMessage = document.getElementById("cabcharge-loader-message");
	const loader = document.getElementById("cabcharge-loader");
	const screenToLoad = state.debugscreen || state.screen;

	if (screenToLoad == "loading") {
		loader.style.display = "block";
		loaderMessage.innerText = "Loading";
		return <div />;
	}

	if (screenToLoad == "downloading") {
		loader.style.display = "block";
		loaderMessage.innerText = "Loading...";
		return <div />;
	}

	loader.style.display = "none";

	if (!screens[screenToLoad]) {
		return (
			<div>
				<h1>umm? {JSON.stringify(state)}</h1>
			</div>
		);
	}

	return screens[screenToLoad];
}

screens["instructions"] = (state, actions) => {
	if (state.brand == "13cabs") {
		return (
			<div>
				<div
					style={{
						padding: "37px 35px 32px",
						backgroundColor: "#000",
					}}
				>
					<img width="208" height="26" alt="13cabs Logo" class="logo" src="./public/img/logo-13cabs-card-screen.png" />
				</div>
				<div class="content">
					<Title>Open Apple Wallet to find your 13cabs Digital Pass</Title>
					<p>Tap the Apple Wallet icon on your iPhone to find your 13cabs Digital Pass.</p>

					<p style={{ textAlign: "center", margin: "35px 0" }}>
						<a href={state.downloadUrl}>
							<img
								width="300"
								height="601"
								src="./public/img/img-iphone-x-wallet-icon-13cabs.png"
								alt="Add to Apple Wallet"
							/>
						</a>
					</p>
					<hr />

					<Title>I can’t find my pass, what should I do?</Title>

					<p>
						<strong>Please try adding the pass again by following the step-by-step instructions below:</strong>
					</p>

					<p>
						<strong>1.</strong> Start by selecting the Add to Apple Wallet button below
					</p>

					<p style={{ textAlign: "center", margin: "35px 0" }}>
						<a href={state.downloadUrl}>
							<img
								style={{ width: "200px" }}
								width="200"
								height="68"
								src="./public/img/btn_add_to_apple_wallet.svg"
								alt="Add to Apple Wallet"
							/>
						</a>
					</p>

					<SubHeading>On iPhone</SubHeading>
					<p>
						<strong>iPhone 6 or later and with iOS 9 and later</strong>
					</p>
					<p>
						<strong>1.</strong> Tap Next
					</p>
					<p style={{ textAlign: "center", margin: "35px 0" }}>
						<img alt="step 1 Tap Next" width="300" height="602" src="public/img/img-step-1-iphone_2-13cabs.png" />
					</p>
					<p>
						<strong>2.</strong> Tap Done
					</p>
					<p style={{ textAlign: "center", margin: "35px 0" }}>
						<img alt="step 1" width="300" height="602" src="public/img/img-step-2-iphone_2-13cabs.png" />
					</p>

					<SubHeading>On Mac</SubHeading>
					<p>
						<strong>iCloud needs to be set up on your Mac and iOS device</strong>
					</p>
					<p>
						Click &apos;<strong>Add to Wallet</strong>&apos; on Safari to Add your Pass.
					</p>
					<p style={{ textAlign: "center" }}>
						<img
							style={{ margin: "30px 15px" }}
							alt="step 1"
							width="269"
							height="419"
							src="public/img/img-tap-add-to-apple-wallet.png"
						/>
					</p>
					<hr />

					<p style={{ textAlign: "center" }}>
						<img alt="How To Pay" width="543" height="295" src="public/img/img-how-to-pay-13cabs.png" />
					</p>

					<SubHeading>HOW TO PAY WITH YOUR PASS</SubHeading>
					<ol class="custom-counter">
						<li>Let your driver know that you’ll be paying with Cabcharge. </li>
						<li>At the end of the trip, select your Cabcharge Digital Pass in your Apple Wallet.</li>
						<li>Hold your device near reader.</li>
						<li>Use Touch ID, Face ID or enter your passcode to authorise payment.</li>
					</ol>
					<Hr />
					<p>
						For further information please refer to our{" "}
						<a href="https://www.cabcharge.com.au/conditions-of-use">Conditions of Use</a>.
					</p>
				</div>
			</div>
		);
	}

	return (
		<div>
			<Header />
			<div class="content">
				<Title>Open Apple Wallet to find your Cabcharge Digital Pass</Title>
				<p>Tap the Apple Wallet icon on your iPhone to find your Cabcharge Digital Pass.</p>

				<p style={{ textAlign: "center", margin: "35px 0" }}>
					<a href={state.downloadUrl}>
						<img width="300" height="601" src="./public/img/img-iphone-x-wallet-icon.png" alt="Add to Apple Wallet" />
					</a>
				</p>
				<hr />

				<Title>I can’t find my pass, what should I do?</Title>

				<p>
					<strong>Please try adding the pass again by following the step-by-step instructions below:</strong>
				</p>

				<p>
					<strong>1.</strong> Start by selecting the Add to Apple Wallet button below
				</p>

				<p style={{ textAlign: "center", margin: "35px 0" }}>
					<a href={state.downloadUrl}>
						<img
							style={{ width: "200px" }}
							width="200"
							height="68"
							src="./public/img/btn_add_to_apple_wallet.svg"
							alt="Add to Apple Wallet"
						/>
					</a>
				</p>

				<SubHeading>On iPhone</SubHeading>
				<p>
					<strong>iPhone 6 or later and with iOS 9 and later</strong>
				</p>
				<p>
					<strong>1.</strong> Tap Next
				</p>
				<p style={{ textAlign: "center", margin: "35px 0" }}>
					<img alt="step 1 Tap Next" width="300" height="602" src="public/img/img-step-1-iphone_2.png" />
				</p>
				<p>
					<strong>2.</strong> Tap Done
				</p>
				<p style={{ textAlign: "center", margin: "35px 0" }}>
					<img alt="step 1" width="300" height="602" src="public/img/img-step-2-iphone_2.png" />
				</p>

				<SubHeading>On Mac</SubHeading>
				<p>
					<strong>iCloud needs to be set up on your Mac and iOS device</strong>
				</p>
				<p>
					Click &apos;<strong>Add to Wallet</strong>&apos; on Safari to Add your Pass.
				</p>
				<p style={{ textAlign: "center" }}>
					<img
						style={{ margin: "30px 15px" }}
						alt="step 1"
						width="269"
						height="419"
						src="public/img/img-tap-add-to-apple-wallet.png"
					/>
				</p>
				<hr />

				<p style={{ textAlign: "center" }}>
					<img alt="How To Pay" width="543" height="295" src="public/img/img-how-to-pay.png" />
				</p>

				<SubHeading>HOW TO PAY WITH YOUR PASS</SubHeading>
				<ol class="custom-counter">
					<li>Let your driver know that you’ll be paying with Cabcharge. </li>
					<li>At the end of the trip, select your Cabcharge Digital Pass in your Apple Wallet.</li>
					<li>Hold your device near reader.</li>
					<li>Use Touch ID, Face ID or enter your passcode to authorise payment.</li>
				</ol>
				<Hr />
				<p>
					For further information please refer to our{" "}
					<a href="https://www.cabcharge.com.au/conditions-of-use">Conditions of Use</a>.
				</p>
			</div>
		</div>
	);
};

screens["send-notification-success"] = (state, actions) => (
	<div>
		<Header />
		<div class="content">
			<Title>Notification Sent</Title>
			<Paragraphs>
				<p>
					We just notified <strong>{state.custodianName}</strong> that you were unable to add your Cabcharge Digital Pass to
					your smartphone.
				</p>
			</Paragraphs>
		</div>
	</div>
);

screens["send-notification-error"] = (state, actions) => (
	<div>
		<Header />
		<div class="content">
			<Title>Notification Failed</Title>
			<Paragraphs>
				<p>
					Sorry, the notification has failed to send to <strong>{state.custodianName}</strong>. Please contact
					<strong> {state.custodianName}</strong> via phone or email to let them know that your device is not supported.
				</p>
			</Paragraphs>
		</div>
	</div>
);

screens["not-supported"] = (state, actions) => (
	<div>
		<Header />
		<div class="content">
			<Title>Unsupported Device</Title>
			<SubHeading style={{ clear: "left", color: "#000", fontSize: "18px", letterSpacing: "1px" }}>
				iPhone 6 or later with iOS 9 and later is required
			</SubHeading>
			<Paragraphs>
				<p>
					Please try again by opening the confirmation email on your iPhone. Your Cabcharge Digital Pass should start
					downloading automatically.
				</p>
				<p>Alternatively, you could use Safari to add your pass if iCloud is set up on your Mac and iOS device.</p>
				<p>
					If you are unable to add the pass to your smartphone please notify <strong>{state.custodianName}</strong> by
					selecting the button below.
				</p>
			</Paragraphs>
			{state.processing ? <Loading /> : <Button onclick={() => actions.sendNotification()}>Send Notification</Button>}
		</div>
	</div>
);

screens["error"] = (state, actions) => (
	<div>
		<Header />
		<div class="content">
			<Title>Oops, an error has occured</Title>
			<Paragraphs>
				<p>
					An error has occured loading your digital pass order. Please contact our support team at{" "}
					<a href="mailto:digital-tickets-support@cabcharge.com.au">digital-tickets-support@cabcharge.com.au</a>
				</p>
			</Paragraphs>
		</div>
	</div>
);

screens["registration-success"] = (state, actions) => (
	<div>
		<Header />
		<div class="content">
			<div
				style={{
					backgroundImage: "url(public/img/img-add-pass-success.png)",
					backgroundRepeat: "no-repeat",
					backgroundSize: "cover",
					backgroundPosition: "center center",
					minHeight: "215px",
					marginBottom: "35px",
				}}
			/>

			<Title style={{ float: "left", marginBottom: "6px" }}>Congratulations!</Title>
			<img
				width="80"
				height="80"
				style={{ marginTop: "5px", float: "right" }}
				alt="Apple Wallet Icon"
				src="./public/img/icon-apple-wallet.png"
			/>
			<SubHeading style={{ clear: "left", margin: "0 90px 0 0", color: "#000", fontSize: "18px", letterSpacing: "1px" }}>
				Your Cabcharge Digital Pass has been added to your Apple Wallet
			</SubHeading>
			<div style={{ clear: "both" }} />
			<Hr />

			<SubHeading>HOW TO PAY WITH YOUR PASS</SubHeading>

			<ol class="custom-counter">
				<li>Let your driver know that you’ll be paying with Cabcharge. </li>
				<li>At the end of the trip, select your Cabcharge Digital Pass in your Apple Wallet.</li>
				<li>Hold your device near reader.</li>
				<li>Use Touch ID, Face ID or enter your passcode to authorise payment.</li>
			</ol>

			<Hr />

			<p>
				For further information please refer to our{" "}
				<a href="https://www.cabcharge.com.au/conditions-of-use">Conditions of Use</a>.
			</p>
		</div>
	</div>
);
